import { render, staticRenderFns } from "./boat-card.vue?vue&type=template&id=77b5f72c&scoped=true"
import script from "./boat-card.vue?vue&type=script&lang=js"
export * from "./boat-card.vue?vue&type=script&lang=js"
import style0 from "./boat-card.vue?vue&type=style&index=0&id=77b5f72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5f72c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,FavoriteButton: require('/var/www/tubber-new/components/global/FavoriteButton.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default,VCurrency: require('/var/www/tubber-new/components/global/v/currency.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
